import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import {Router} from "@angular/router"
import { Config } from 'src/assets/configuration/config';
import { ApiService} from '../../share/service/api.service';

declare var jslib;
@Component({
  selector: 'left-select',
  templateUrl: './leftSelect.component.html'
})
export class LeftSelectComponent implements OnInit {
  constructor(
    public baseApi : ApiService,
    private router: Router
  ) { }

  @Input() onChange;
  @Output() ChangeEvt = new EventEmitter();

  public config = Config;
  public Query = {
    main:0,
    select:'',
    name:''
  }
  public LeftMenu;
  public LeftSecMenu;

  ngOnInit() {
    this.SetLeftMenu();
    //console.log('ngOnInit Set',this.onChange);
  }
  SetLeftMenu(){
    //設定選單
    this.LeftMenu = this.config.Search;
    var Selected = this.LeftMenu.find((item)=>{return item.value == this.Query.main})
    this.LeftSecMenu = Selected.SecMenu;

    //取得產業
    this.baseApi.apiGet('v1/asset/industries',{all:false}).then((res_i:any)=>{
      ////console.log('industries',res_i);
      if(res_i){
        var _prod = this.LeftMenu.find((item)=>{return item.value == 1});
        _prod['SecMenu'] = [];
        res_i.forEach(_i => {
          var _item = {
            name: _i['name'],
            value: _i['id'],
          };
          _prod['SecMenu'].push(_item);
        });
      }
      //取得買主所在地
      this.baseApi.apiGet('v1/asset/countries',{all:false}).then((res_c:any)=>{
       // //console.log('res_c',res_c);
        var _area = this.LeftMenu.find((item)=>{return item.value == 3});
        _area['SecMenu'] = [];
        if(res_c){
          res_c.forEach(_c => {
            var _item = {
              name: _c['continental'] + ' ' + _c['name'],
              value: _c['id'],
            };
            _area['SecMenu'].push(_item);
          });
        }
      });
    });
    
    
  }
  LeftMenuSet(){
   this.Query.select = '';
   var Selected = this.LeftMenu.find((item)=>{return item.value == this.Query.main})
   //console.log('Selected',Selected);
   this.LeftSecMenu = Selected.SecMenu;
  }
  SearchSubmit(){
  if(this.Query.main != 4 && this.Query.main != 5){
    var Selected = this.LeftSecMenu.find((item)=>{return item.value == this.Query.select});
        if(Selected && this.Query.select != ''){
          this.Query.name = Selected.name;
        }
    }else{
      this.Query.name = this.Query.select;
    }
    if(this.Query.select != ''){
      if(this.onChange == true){
        this.ChangeEvt.emit(this.Query);
      }else{
        jslib.SetStorage('search',this.Query);
        this.router.navigateByUrl('/search');
      }
    }
  };
  eventHandler(code){
    if(code == 13){
      this.SearchSubmit();
    }
  }
}
